import { Helmet } from 'abi'
import { Font, Padding, VirtualHeadBox, VirtualTable } from './virt'

export * from './ext'
import { day_stamp_img, hamrah_logo_img, day_logo_img } from './shared'
import { rand, s2hm, FONTS } from './shared'

export async function _day_to_image(helmet: Helmet): Promise<Blob> {
    let canvas = document.createElement('canvas')
    const X = 2
    canvas.width = 928 * X
    // canvas.height = canvas.width * Math.SQRT2
    canvas.height = 1280 * X

    const S = Math.sqrt(Math.pow(canvas.width, 2) + Math.pow(canvas.height, 2))

    let ctx = canvas.getContext('2d')!
    if (!ctx) throw new Error('[helmet_to_image] could not get context')

    for (let f of FONTS) {
        ctx.fillText('لود', 100, 100)
        ctx.font = '10px ' + f
        // await document.fonts.ready
    }

    // await document.fonts.ready
    // await new Promise(r => setTimeout(r, 1000))

    // const GKBG = '#00415699'
    // const GHBG = '#1E3C00'
    // const FG = '#f2f2f2'
    // const BG = '#040404'
    // const FG = 'red'

    const GKBG = '#eff9fe'
    const GHBG = '#fff6da'
    const FG = '#000'
    const BG = '#fff'

    ctx.fillStyle = BG
    ctx.fillRect(0, 0, canvas.width, canvas.height)

    let day_logo = document.createElement('img')
    let hamrah_logo = document.createElement('img')
    let stamp = document.createElement('img')
    day_logo.src = day_logo_img
    hamrah_logo.src = hamrah_logo_img
    stamp.src = day_stamp_img

    await Promise.all([
        new Promise(r => (day_logo.onload = r)),
        new Promise(r => (hamrah_logo.onload = r)),
        new Promise(r => (stamp.onload = r)),
        document.fonts.ready,
    ])

    let ldw = wp(0.152)
    ctx.drawImage(
        day_logo,
        wp(0.685),
        hp(0.055),
        ldw,
        (day_logo.naturalHeight / day_logo.naturalWidth) * ldw
    )

    ldw = wp(0.102)
    ctx.drawImage(
        hamrah_logo,
        wp(0.53),
        hp(0.028),
        ldw,
        (hamrah_logo.naturalHeight / hamrah_logo.naturalWidth) * ldw
    )

    function wp(a: number): number {
        return canvas.width * a
    }

    function hp(a: number): number {
        return canvas.height * a
    }

    function fs(a: number): number {
        return ~~(S * (a / 100))
    }

    const GBW = wp(0.349)
    const GBLW = wp(0.001)
    const GRGAP = hp(0.01)

    const GHFONT: Font = { size: fs(0.9), name: 'b-nazanin', bold: true }
    const GRFONT: Font = { size: fs(0.7), name: 'b-nazanin' }

    // const GBHSW = GBW / 2 + wp(0.018)

    const GPAD: Padding = {
        top: hp(0.005),
        bottom: hp(0.005),
        left: wp(0.003),
        right: wp(0.003),
    }

    // ctx.save()
    // ctx.font = fs(0.5) + 'px roboto'
    // ctx.fillStyle = FG
    // ctx.translate(wp(0.05), hp(0.016))
    // ctx.rotate((90 * Math.PI) / 180)
    // let SSS = '      '
    // let SSST = `www.hamrah-insurance.com${SSS}🏍️${SSS}`
    //     .repeat(9)
    //     .slice(0, -(SSS.length * 2 + 1))
    // ctx.fillText(SSST, 0, 0)
    // ctx.restore()
    //
    // ctx.save()
    // ctx.font = fs(0.5) + 'px roboto'
    // ctx.fillStyle = FG
    // ctx.translate(canvas.width - wp(0.1), hp(0.016))
    // ctx.rotate((-90 * Math.PI) / 180)
    // // ctx.fillText(SSST, 0, wp(0.1) - canvas.width)
    // ctx.fillText(SSST, hp(0.132) - canvas.height, wp(0.05))
    // ctx.restore()

    let vl1 = new VirtualHeadBox({
        header: 'بیمه نامه شخص ثالث و حوادث راننده',
        vpad: { top: hp(0.003), bottom: hp(0.003), right: wp(0.005) },
        // text: 'مرکزی\nشماره بیمه\nشماره اقتصادی',
        text: `کد یکتای بیمه مرکزی: ${helmet.unique_code}      شماره اقتصادی: 10102822596
تاریخ صدور: ${helmet.issue_date}        ساعت صدور: ${s2hm(helmet.issue_time)}
شماره بیمه نامه: ${helmet.issue_year}/31/${helmet.issuer_code}/${helmet.insurance_number} 
اعتبار از ساعت ۲۴ روز   ${helmet.start_date}   تا ساعت ۲۴ روز   ${helmet.expiration_date}
بیمه گر قبلی:  ${helmet.past_insurer.padEnd(25, ' ')} تاریخ انقضاء بیمه نامه قبلی: ${helmet.past_expiration_date}`,
        vfont: { size: fs(0.8), name: 'b-nazanin' },
        color: FG,
        width: GBW,
        hpad: { top: hp(0.004), bottom: hp(0.004) },
        hbg: GHBG,
        hfont: GHFONT,
        line_width: GBLW,
        added_line_height: hp(0.003),
    })
    vl1.draw(ctx, wp(0.128), hp(0.016))

    let vl2 = new VirtualTable({
        line_width: GBLW,
        width: GBW,
        color: FG,
        header: 'حق بیمه (ریال)',
        hfont: GHFONT,
        kfont: GRFONT,
        center_value: true,
        rows: [
            [
                'حق بیمه شخص ثالث',
                helmet.third_party_insurance_amount.toLocaleString(),
            ],
            [
                'حق بیمه حوادث راننده',
                helmet.passenger_insurance_amount.toLocaleString(),
            ],
            [
                'حق بیمه پوشش مازاد مالی',
                helmet.financial_surplus_insurance_amount.toLocaleString(),
            ],
            [
                'حق بیمه پوشش مازاد حوادث راننده',
                helmet.life_surplus_insurance_amount.toLocaleString(),
            ],
            ['جریمه صندوق', helmet.fund_fine.toLocaleString()],
            [
                'مالیات و عوارض ارزش افزوده',
                (helmet.added_tax + helmet.added_toll).toLocaleString(),
            ],
            ['درصد تخفیف بیمه شخص ثالث', ''],
            ['درصد تخفیف بیمه حوادث راننده', ''],
            ['مبلغ تخفیفات', ''],
            ['نحوه پرداخت حق بیمه', 'نقط و اقساط'],
            [
                'کل مبلغ حق بیمه',
                (
                    helmet.total_insurance_amount +
                    helmet.added_tax +
                    helmet.added_toll
                ).toLocaleString(),
            ],
        ],
        vfont: GRFONT,
        hbg: GHBG,
        hpad: GPAD,
        vpad: GPAD,
        kpad: GPAD,
        kbg: GKBG,
    })
    vl2.draw(ctx, wp(0.128), hp(0.016) + vl1.height + GRGAP)

    let vl3 = new VirtualHeadBox({
        header: 'روش های استعلام اصالت بیمه نامه',
        vpad: { top: hp(0.003), bottom: hp(0.003), right: wp(0.005) },
        // text: 'مرکزی\nشماره بیمه\nشماره اقتصادی',
        text: `1- مراجعه به سایت بیمه مرکزی ایران به آدرس www.centinsur.ir
2- از طریق QR Code مندرج در بیمه نامه
نکته: برای کسب اطلاع از حقوق و تعهدات بیمه گذار و نحوه اعلام و دریافت خسارت در بیمه نامه شخص ثالث و حوادث راننده به سایت www.dayins.com مراجعه کنید و یا با شماره تلفن ۱۶۷۱ داخلی 1111 تماس بگیرید.
`,
        vfont: { size: fs(0.85), name: 'b-nazanin' },
        color: FG,
        width: GBW,
        hpad: { top: hp(0.004), bottom: hp(0.004) },
        hbg: GHBG,
        hfont: GHFONT,
        line_width: GBLW,
        added_line_height: hp(0.004),
    })
    vl3.draw(ctx, wp(0.128), hp(0.016) + vl1.height + vl2.height + GRGAP * 2)

    let vl4 = new VirtualHeadBox({
        header: 'مهر و امضا صادرکننده',
        vpad: { top: hp(0.003), bottom: hp(0.003), right: wp(0.005) },
        // text: 'مرکزی\nشماره بیمه\nشماره اقتصادی',
        text: `\n\n\n\n\n\n\n\n\n\n\nنام و کد معرف: ${helmet.reagent}`,
        vfont: { size: fs(0.75), name: 'b-nazanin' },
        color: FG,
        width: GBW,
        hpad: { top: hp(0.004), bottom: hp(0.004) },
        hbg: GHBG,
        hfont: GHFONT,
        line_width: GBLW,
    })
    vl4.draw(
        ctx,
        wp(0.128),
        hp(0.016) + vl1.height + vl2.height + vl3.height + GRGAP * 3
    )

    ctx.save()

    ldw = wp(0.18)
    let stamp_x = wp(0.128) + (vl4.width - ldw) / 2 + rand(wp(-0.05), wp(0.05))
    let stamp_y =
        hp(0.025) +
        vl4.header_height +
        vl1.height +
        vl2.height +
        vl3.height +
        GRGAP * 3

    let stamp_height = (stamp.naturalHeight / stamp.naturalWidth) * ldw
    ctx.translate(stamp_x + ldw / 2, stamp_y + stamp_height / 2)
    ctx.rotate((rand(-5, 5) * Math.PI) / 180)
    ctx.drawImage(stamp, -(ldw / 2), -(stamp_height / 2), ldw, stamp_height)
    ctx.restore()

    //////////////////////////////

    let vr1 = new VirtualTable({
        line_width: GBLW,
        color: FG,
        header: 'بیمه گذار',
        hfont: GHFONT,
        hpad: GPAD,
        hbg: GHBG,
        vfont: GRFONT,
        vpad: GPAD,
        kfont: GRFONT,
        kpad: GPAD,
        kbg: GKBG,
        width: GBW,
        rows: [
            ['نام بیمه گذار', helmet.insurer],
            ['شماره اقتصادی', helmet.economic_number + ''],
            ['تلفن بیمه گذار', helmet.insurer_phone + ''],
        ],
    })
    vr1.draw(ctx, wp(0.502), hp(0.116))

    let vr2 = new VirtualTable({
        line_width: GBLW,
        color: FG,
        header: 'مشخصات خودرو',
        hfont: GHFONT,
        center_value: true,
        hpad: GPAD,
        hbg: GHBG,
        vfont: GRFONT,
        vpad: GPAD,
        kfont: GRFONT,
        kpad: GPAD,
        kbg: GKBG,
        width: GBW,
        rows: [
            ['شماره شاسی وسیله نقلیه', helmet.chassis],
            ['شماره موتور وسیله نقلیه', helmet.engine],
            [
                'شماره انتظامی وسیله نقلیه',
                helmet.plate_number +
                    ' ' +
                    helmet.plate_city +
                    ' ' +
                    helmet.plate_serial,
            ],
            ['شماره VIN وسیله نقلیه', helmet.vin],
            ['سیستم وسیله نقلیه', helmet.v_system],
            ['ظرفیت وسیله نقلیه', helmet.passenger_count + ' نفر'],
            ['نوع وسیله نقلیه', helmet.v_name],
            ['کاربری وسیله نقلیه', helmet.v_usage],
            ['سال ساخت', helmet.manufacture_year + ''],
        ],
    })
    vr2.draw(ctx, wp(0.502), hp(0.116) + vr1.height + GRGAP)

    let vr3 = new VirtualTable({
        line_width: GBLW,
        color: FG,
        header: 'تعهد بیمه نامه',
        hfont: GHFONT,
        center_value: true,
        hpad: GPAD,
        hbg: GHBG,
        vfont: GRFONT,
        vpad: GPAD,
        kfont: GRFONT,
        kpad: GPAD,
        kbg: GKBG,
        width: GBW,
        rows: [
            [
                'تعهد مالی بیمه شخص ثالث',
                helmet.airrm_cover_financial.toLocaleString() + ' میلیون ریال',
            ],
            [
                'تعهد بدنی بیمه شخص ثالث',
                helmet.airrm_cover_life.toLocaleString() + ' میلیون ریال',
            ],
            [
                'تعهد بدنی بیمه حوادث راننده',
                helmet.airrm_cover_passenger.toLocaleString() + ' میلیون ریال',
            ],
        ],
    })
    vr3.draw(ctx, wp(0.502), hp(0.116) + vr1.height + vr2.height + GRGAP * 2)

    let vr4 = new VirtualTable({
        line_width: GBLW,
        color: FG,
        header: 'شرایط پرداخت حق بیمه',
        hfont: GHFONT,
        center_value: true,
        hpad: GPAD,
        hbg: GHBG,
        vfont: GRFONT,
        vpad: GPAD,
        kfont: GRFONT,
        kpad: GPAD,
        kbg: GKBG,
        width: GBW,
        rows: [
            ['مبلغ نقدی', ''],
            ['قسط اول و تاریخ سررسید', ''],
            ['قسط دوم و تاریخ سررسید', ''],
            ['قسط سوم و تاریخ سررسید', ''],
            ['قسط چهارم و تاریخ سررسید', ''],
            ['قسط پنجم و تاریخ سررسید', ''],
            ['قسط ششم و تاریخ سررسید', ''],
            ['شماره حساب واریز حق بیمه', ''],
            ['نام و کد واحد صدور', helmet.issuer],
            ['تلفن', '555040'],
            ['بانک', ''],
        ],
    })
    vr4.draw(
        ctx,
        wp(0.502),
        hp(0.116) + vr1.height + vr2.height + vr3.height + GRGAP * 3
    )

    let blob = await new Promise<Blob | null>(r =>
        canvas.toBlob(r, 'image/png')
    )
    if (!blob) {
        throw new Error('[helmet_to_image] could not get do canvas.toBlob')
    }

    return blob
}
